module.exports = __webpack_public_path__ + "html/sliding-switch.45c529.html";


/*****************
 ** WEBPACK FOOTER
 ** /mnt/jenkins/jobs/master/workspace/core/client/common/Forms/sliding-switch.html
 ** module id = 527
 ** module chunks = 0 1 2 3 5 11
 **/